import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetUsers = {
  getUsers: { data: null, loading: false, error: null },
};

export const getUsers = createAsyncThunk('user/getUsers', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/`, {
      params: data?.isAll ? data : { type: 'candidate', ...data },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetUsers = {
  [getUsers.pending]: (state) => {
    state.getUsers.loading = true;
    state.getUsers.error = null;
  },
  [getUsers.fulfilled]: (state, action) => {
    state.getUsers.loading = false;
    state.getUsers.data = action.payload;
    state.getUsers.error = null;
  },
  [getUsers.rejected]: (state, action) => {
    state.getUsers.loading = false;
    state.getUsers.error = action.payload;
  },
};
